import { MACRO_KCAL } from "../model/constants";

/**
 * Share of calories from each macronutrient, as whole percentages that sum to
 * 100. Ported from the mobile `dayIntakePieChartContainer`.
 */

export type MacroPercentages = {
  carbs: number;
  protein: number;
  fat: number;
};

type MacroGrams = { carbs: number; protein: number; fat: number };

const ensurePercentagesSum100 = (raw: MacroPercentages): MacroPercentages => {
  const rounded: MacroPercentages = {
    carbs: Math.round(raw.carbs),
    protein: Math.round(raw.protein),
    fat: Math.round(raw.fat),
  };
  const diff = 100 - (rounded.carbs + rounded.protein + rounded.fat);
  if (diff !== 0) {
    const largest = (Object.keys(rounded) as (keyof MacroPercentages)[]).reduce(
      (a, b) => (raw[a] > raw[b] ? a : b)
    );
    rounded[largest] += diff;
  }
  return rounded;
};

export const calculateMacroPercentages = (
  grams: MacroGrams,
  totalCalories: number
): MacroPercentages => {
  if (totalCalories <= 0) return { carbs: 0, protein: 0, fat: 0 };
  return ensurePercentagesSum100({
    carbs: ((grams.carbs * MACRO_KCAL.carbs) / totalCalories) * 100,
    protein: ((grams.protein * MACRO_KCAL.protein) / totalCalories) * 100,
    fat: ((grams.fat * MACRO_KCAL.fat) / totalCalories) * 100,
  });
};
